// ** Root Slice & Helper Functions
import { baseApi } from './baseApi'
import { customErrorHandler } from './customErrorHandler'

// ** Constants
const C_CORPORATION_TAX_RATE = 'C Corporation Tax Rate'

/** One flattened row of `GET /tax-rate` (`taxRates[]`). */
export interface TaxRateRow {
	taxRateId: number
	stateId?: number | null
	stateName?: string | null
	year: number
	taxRate: number
	name: string
	taxRateTypeId: number
	taxRateIntervalId?: number | null
	incomeLowerLimit?: number | null
	incomeUpperLimit?: number | null
	filingStatusId?: number | null
	filingStatusName?: string | null
}

export interface GetTaxRatesResponse {
	taxRates: TaxRateRow[]
	total: number
	pageSize: number
	pageNum: number
}

export interface GetTaxRatesVariables {
	stateName: string
	year: number
	taxRateType?: string
}

/**
 * `GET /tax-rate` returns one flattened row per state/year/rate-type entry;
 * bracket rates come back as one row per bracket with lower/upper limits.
 * Used by the Analytics prefill to resolve the state C-Corp rate.
 */
const taxRatesApi = baseApi.injectEndpoints({
	endpoints: (build) => ({
		getTaxRates: build.query<GetTaxRatesResponse, GetTaxRatesVariables>({
			query: ({ stateName, year, taxRateType = C_CORPORATION_TAX_RATE }) => ({
				url: '/tax-rate',
				params: {
					stateName,
					year,
					taxRateType,
					pageNum: 1,
					pageSize: 100
				}
			}),
			transformErrorResponse: customErrorHandler
		})
	}),
	overrideExisting: true
})

export const { useGetTaxRatesQuery, useLazyGetTaxRatesQuery } = taxRatesApi
